import { render, staticRenderFns } from "./TTCTable.vue?vue&type=template&id=04e631da&scoped=true&"
import script from "./TTCTable.vue?vue&type=script&lang=js&"
export * from "./TTCTable.vue?vue&type=script&lang=js&"
import style0 from "./TTCTable.vue?vue&type=style&index=0&id=04e631da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e631da",
  null
  
)

export default component.exports